import {
  detectApiSupport,
  detectBrowser,
  detectBrowserInfo,
  detectNetworkInfo,
  detectOperatingSystem,
  detectPlatform,
  getEnvironmentInfo,
  isBrowser,
  isBun,
  isDeno,
  isNode,
  isWebWorker,
} from '../src/index.ts';

const main = document.createElement('main');
const heading = document.createElement('h1');
heading.textContent = 'JS Env Utility Demo';
main.append(heading);

function addValue(label: string, value: unknown, formatted = false): void {
  const term = document.createElement('dt');
  const description = document.createElement(formatted ? 'pre' : 'dd');
  term.textContent = label;
  description.textContent = typeof value === 'string' ? value : JSON.stringify(value, null, 2);
  details.append(term, description);
}

const environment = getEnvironmentInfo();
const details = document.createElement('dl');
main.append(details);

addValue('Is Node.js', isNode());
addValue('Is Deno', isDeno());
addValue('Is Bun', isBun());
addValue('Is Browser', isBrowser());
addValue('Is Web Worker', isWebWorker());
addValue('Platform', detectPlatform());
addValue('Operating System', detectOperatingSystem());
addValue('Browser', detectBrowser());
addValue('Browser Info', detectBrowserInfo(), true);
addValue('API Support', detectApiSupport(), true);
addValue('Network Info', detectNetworkInfo(), true);
addValue('Full Environment Info', environment, true);

document.body.replaceChildren(main);
console.log('Environment info:', environment);
